import Vue from 'vue'
import VueRouter from 'vue-router'

import Auth
  from '../views/Auth.vue'

import BuyerHome
  from '../views/BuyerHome.vue'

import SellerHome
  from '../views/SellerHome.vue'

import Books
  from '../views/Books.vue'

import Wishlist
  from '../views/Wishlist.vue'

import Cart
  from '../views/Cart.vue'

import Checkout
  from '../views/Checkout.vue'

import BookDetails
  from '../views/BookDetails.vue'

import AddBook
  from '../views/AddBook.vue'

import EditBook
  from '../views/EditBook.vue'

import Dashboard
  from '../views/Dashboard.vue'

import NotFound
  from '../views/NotFound.vue'

Vue.use(VueRouter)

const routes = [

  {
    path: '/',
    redirect: '/auth'
  },

  {
    path: '/auth',
    component: Auth,

    meta: {
      guest: true
    }
  },

  {
    path: '/buyer',
    component: BuyerHome,

    meta: {
      requiresAuth: true,
      role: 'buyer'
    }
  },

  {
    path: '/seller',
    component: SellerHome,

    meta: {
      requiresAuth: true,
      role: 'seller'
    }
  },

  {
    path: '/books',
    component: Books,

    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/wishlist',
    component: Wishlist,

    meta: {
      requiresAuth: true,
      role: 'buyer'
    }
  },

  {
    path: '/cart',
    component: Cart,

    meta: {
      requiresAuth: true,
      role: 'buyer'
    }
  },

  {
    path: '/checkout',
    component: Checkout,

    meta: {
      requiresAuth: true,
      role: 'buyer'
    }
  },

  {
    path: '/books/add',
    component: AddBook,

    meta: {
      requiresAuth: true,
      role: 'seller'
    }
  },

  {
    path: '/books/edit/:id',
    component: EditBook,

    meta: {
      requiresAuth: true,
      role: 'seller'
    }
  },

  {
    path: '/books/:ISBN',
    component: BookDetails,

    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/dashboard',
    component: Dashboard,

    meta: {
      requiresAuth: true
    }
  },

  {
    path: '*',
    component: NotFound
  }
]

const router =
  new VueRouter({
    mode: 'hash',

    base:
      process.env.BASE_URL,

    routes
  })

router.beforeEach(
  (to, from, next) => {

    const savedUser =
      localStorage.getItem(
        'currentUser'
      )

    const user =
      savedUser
        ? JSON.parse(savedUser)
        : null

    const isAuthenticated =
      !!user

    // -------------------------
    // Login required
    // -------------------------

    if (
      to.meta.requiresAuth &&
      !isAuthenticated
    ) {
      next('/auth')
      return
    }

    // -------------------------
    // Guest pages
    // -------------------------

    if (
      to.meta.guest &&
      isAuthenticated
    ) {

      if (
        user.role === 'seller'
      ) {
        next('/seller')
      } else {
        next('/buyer')
      }

      return
    }

    // -------------------------
    // Role protection
    // -------------------------

    if (
      to.meta.role &&
      user &&
      user.role !==
        to.meta.role
    ) {

      if (
        user.role === 'seller'
      ) {
        next('/seller')
      } else {
        next('/buyer')
      }

      return
    }

    next()
  }
)

export default router